import { Component, OnDestroy, Input } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";

import {
  getSiteDispenserList,
  getSiteFuelPointList,
} from "src/app/store/actions/sites/sites.actions";
import {
  AppState,
  siteDispensorsLoadedState,
  siteFuelPointLoadedState,
} from "src/app/store/reducers";

import { SiteDispenserDTO } from "src/app/models/Sites/siteDispenserDTO";
import { SiteFuelPointDTO } from "src/app/models/Sites/siteFuelPointDTO";

import { DispenserFormDialogComponent } from "./dialog/dispenser-form-dialog.component";

@Component({
  selector: "site-dispenser-details",
  templateUrl: "./dispenser-details.component.html",
  styleUrls: ["./dispenser-details.component.scss"],
})
export class DispenserDetailsComponent implements OnDestroy {
  _siteCode: string;

  @Input() set siteCode(value) {
    this._siteCode = value;
    if (this._siteCode) {
      this.loadDispenser(this._siteCode);
      this.loadFuelPoints(this._siteCode);
    }
  }

  @Input() permissionResource: string;

  //Dispenser List
  dispenserSub: Subscription;
  dispenserList$: Observable<SiteDispenserDTO[]>;
  dispenserList: SiteDispenserDTO[];

  //Site Fuel Points List
  fuelPointList$: Observable<SiteFuelPointDTO[]>;
  fuelPointList: SiteFuelPointDTO[];
  fuelPointSub: Subscription;

  currentDispenser: SiteDispenserDTO;
  isDispenserSelected = false;

  constructor(private store: Store<AppState>, public dialog: MatDialog) {
    this.dispenserList$ = this.store.pipe(select(siteDispensorsLoadedState));
    this.fuelPointList$ = this.store.pipe(select(siteFuelPointLoadedState));
  }

  loadDispenser(code: string) {
    this.dispenserSub = this.dispenserList$.subscribe(
      (dispensers: SiteDispenserDTO[]) => {
        this.dispenserList = dispensers;
        if (dispensers && dispensers.length && this.currentDispenser) {
          const { code: currentDispenserCode } = this.currentDispenser;
          this.currentDispenser = dispensers.find(
            ({ code }) => code === currentDispenserCode
          );
        }
        this.resetDispenser();
      }
    );
    this.store.dispatch(
      getSiteDispenserList({
        code,
        pageReq: { realSize: true, offset: 0, limit: 999 },
      })
    );
  }

  loadFuelPoints(code: string) {
    this.fuelPointSub = this.fuelPointList$.subscribe(
      (fuelPoints: SiteFuelPointDTO[]) => {
        this.fuelPointList = fuelPoints;
      }
    );
    this.store.dispatch(
      getSiteFuelPointList({
        code,
        pageReq: { realSize: true, offset: 0, limit: 999 },
      })
    );
  }

  resetDispenser() {
    this.dialog.closeAll();
    this.isDispenserSelected = false;
    this.currentDispenser = null;
  }
  
  selectDispenser(dispenser: SiteDispenserDTO) {
    this.isDispenserSelected = true;
    this.currentDispenser = dispenser;

    this.dialog.closeAll();
    this.openDispenserFormDialog(false);
  }

  create() {
    this.isDispenserSelected = false;
    this.currentDispenser = null;

    this.openDispenserFormDialog(true);
  }

  openDispenserFormDialog(isCreate: boolean) {
    this.dialog.open(DispenserFormDialogComponent, {
      autoFocus: false,
      data: {
        isCreate,
        siteCode: this._siteCode,
        currentDispenser: this.currentDispenser,
        fuelPointList: this.fuelPointList,
      },
    });
  }

  ngOnDestroy(): void {
    if (this.dispenserSub) {
      this.dispenserSub.unsubscribe();
    }
    if (this.fuelPointSub) {
      this.fuelPointSub.unsubscribe();
    }
  }
}
